import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyWrapperAddonsComponent } from './addons.wrapper';
import { addonsExtension } from './addons.extension';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [FormlyWrapperAddonsComponent],
  exports: [FormlyWrapperAddonsComponent],
  imports: [
    CommonModule,
    MatIconModule,
    FormlyModule.forChild({
      wrappers: [{ name: 'addons', component: FormlyWrapperAddonsComponent }],
      extensions: [
        { name: 'addons', extension: { onPopulate: addonsExtension } },
      ],
    }),
    MatFormFieldModule,
  ],
})
export class FormFieldsAddonsModule {}
